export const grid = {
  gutterWidth: 0,
  gutterWidthColumns: 48,
  gridColumns: 12,
  containerWidths: ['100%', '100%', '100%', '100%', '100%'],
};
